module.exports = __webpack_public_path__ + "static/media/connect_with_stripe.9f75731a.png";